export const SET_USER_INFO = 'user/SET_USER_INFO'
export const SET_ACCESS_TOKEN = 'user/SET_ACCESS_TOKEN';
export const SET_DICT = 'user/SET_DICT'
export const SET_LOGGED = 'user/SET_LOGGED'
export const SET_SUBSTATION = 'metadata/SET_SUBSTATION';
export const SET_WEB_CONFIG = 'user/SET_WEB_CONFIG'
export const SET_SHARE_INFO = 'user/SET_SHARE_INFO'
export const SET_OPEN = 'use/SET_OPEN'
export const SET_INCLUDES = 'user/SET_INCLUDES'
export const REMOVE_INCLUDED = 'user/REMOVE_INCLUDED'
export const SET_REDIRECT_URL = 'user/SET_REDIRECT_URL'
export const SET_USER_TYPE = 'user/SET_USER_TYPE'
export const SET_COMPANY_INFO = 'user/SET_COMPANY_INFO'
export const SET_CAPTCHA_CONFIG = 'user/SET_CAPTCHA_CONFIG'
